import React from "react";

import email from "../../Images/email.png";
import twitter from "../../Images/twitter.png";
import medium from "../../Images/medium.png";

const Footer = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <div className="Ray---Connect---Links">
        <div className="text-center">
          <a href="">
            <i class="fab fa-twitter">
              <img src={email} />
            </i>
          </a>
          <a href="#">
            <i class="fab fa-instagram">
              <img src={twitter} />
            </i>
          </a>
          <a href="#">
            <i class="fab fa-linkedin-in">
              <img src={medium} />
            </i>
          </a>
        </div>
      </div>
    </div>
  );
};
export default Footer;
